export const MeetingOwnerModes = { EACH: 'each', SINGLE: 'single' } as const

export type MeetingOwnerMode = (typeof MeetingOwnerModes)[keyof typeof MeetingOwnerModes]

export const FallbackModes = { SKIP: 'skip', SEND: 'send' } as const

export type FallbackMode = (typeof FallbackModes)[keyof typeof FallbackModes]
